export const API_ENTITIES = '/v1/entity';
export const API_BANKS = '/v1/banks';
export const API_PARAMETERS = '/v1/Parameters';
export const API_ATHLETES = '/v1/athletes'

